
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import { getExchangeAccount, exchangeBean } from '../common/js/api.js'
import { getCookie, setCookie, removeCookie } from '../common/js/utils'
import router from '@/router/index.js'

export default {
directives: {
TransferDom
},
components: {
Popup,
Box,
XButton,
XInput,
Group,
TransferDom
},
methods: {
appoint() {
this.show = true;





},
activity() {
let self = this
this.$router.replace({
path: '/activity/yuexiu/activityappointment',
query: { activityId: this.activityId, partnerId: this.partnerId }
})
}
},
data() {
return {
activityId: '',
partnerId: '',
show:false,
imageWxMini:""
}
},
created() {
let self = this
this.activityId = this.$route.query.activityId
this.partnerId = this.$route.query.partnerId


let insertImgs = "https://wx.test.oouyan.cn/upload/earth/images/appointment/";
if( window.location.origin.indexOf("wx.oouyan.cn")>-1 ){
insertImgs = "https://cdn.oouyan.com/upload/earth/images/appointment/";
}

self.imageWxMini = insertImgs+"wxmin.png";
}
}



// WEBPACK FOOTER //
// ./src/components/partnerQrCode.vue